import React from 'react'
import LoaderSVG from 'svg/icons/LoaderSVG'
import styles from "./Loader.module.scss"

export const Loader = () => {
  return (
    <LoaderSVG className={styles.loader} width='42' height='42'/>
  )
}
